import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import lottie from 'lottie-web/build/player/lottie_light';
import { I18n } from '@mademine/utils';
import animationData from '../../assets/loading.json';
import style from './style.module.less';
var RecognitionLoading = function (_a) {
    var image = _a.image, loadingState = _a.loadingState, doneCallback = _a.doneCallback, tryAgainWhenError = _a.tryAgainWhenError, cropWhenError = _a.cropWhenError, replaceWhenError = _a.replaceWhenError;
    var _animation = useRef(null);
    var _b = useState(false), animationLoaded = _b[0], setAnimationLoaded = _b[1];
    var lottieAnimation = useRef();
    var loadedImages = function () {
        var _a;
        setAnimationLoaded(true);
        (_a = lottieAnimation.current) === null || _a === void 0 ? void 0 : _a.play();
    };
    var animationComplete = function () {
        setTimeout(function () {
            doneCallback();
        }, 500);
    };
    useEffect(function () {
        lottie.setLocationHref(location.href);
        if (_animation.current) {
            lottieAnimation.current = lottie.loadAnimation({
                container: _animation.current,
                renderer: 'svg',
                loop: true,
                autoplay: false,
                initialSegment: [0, 200],
                animationData: animationData,
                assetsPath: 'https://sunzi7n.myuxc.com/assets/'
            });
            lottieAnimation.current.addEventListener('DOMLoaded', loadedImages);
        }
        return function () {
            if (lottieAnimation.current) {
                lottieAnimation.current.removeEventListener('DOMLoaded', loadedImages);
                lottieAnimation.current.removeEventListener('loopComplete', animationComplete);
                lottieAnimation.current.destroy();
            }
        };
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (loadingState === 'success') {
            (_a = lottieAnimation.current) === null || _a === void 0 ? void 0 : _a.setLoop(false);
            (_b = lottieAnimation.current) === null || _b === void 0 ? void 0 : _b.playSegments([201, 270], false);
            (_c = lottieAnimation.current) === null || _c === void 0 ? void 0 : _c.addEventListener('complete', animationComplete);
        }
        else if (loadingState === 'fail') {
            (_d = lottieAnimation.current) === null || _d === void 0 ? void 0 : _d.setLoop(false);
            (_e = lottieAnimation.current) === null || _e === void 0 ? void 0 : _e.playSegments([271, 303], false);
        }
        else {
            (_f = lottieAnimation.current) === null || _f === void 0 ? void 0 : _f.setLoop(true);
            (_g = lottieAnimation.current) === null || _g === void 0 ? void 0 : _g.playSegments([0, 200], false);
        }
    }, [loadingState]);
    var classes = useMemo(function () {
        var display = '_sz-flex';
        if (!animationLoaded)
            display = '_sz-hidden';
        return { display: display };
    }, [animationLoaded]);
    return (_jsxs("div", { className: " _sz-absolute _sz-top-0 _sz-z-20  _sz-h-full _sz-w-full _sz-flex-col _sz-items-center _sz-justify-center _sz-bg-white  ".concat(classes.display), children: [_jsx("div", { className: " _sz-absolute _sz-inset-0  _sz-bg-gird _sz-bg-[length:10%] _sz-opacity-10" }), _jsxs("div", { className: " _sz-relative _sz-z-10 _sz-flex _sz-items-center _sz-justify-center", children: [_jsx("div", { className: style['loading-animation'], ref: _animation }), _jsx("img", { src: image, alt: "head", className: " _sz-absolute -_sz-z-[1] _sz-h-[100px] _sz-w-[100px] _sz-object-contain _sz-p-2 _sz-transition-opacity _sz-duration-500\t", style: { opacity: loadingState === 'playing' ? 100 : 0 } })] }), loadingState !== 'fail' ? (_jsx("div", { className: "_sz-relative _sz-z-10 _sz-mt-6 _sz-rounded-[19px] _sz-bg-[rgba(0,0,0,0.4)] _sz-py-1.5 _sz-px-4 _sz-text-sm  _sz-text-white ".concat(loadingState === 'success' ? '!_sz-bg-[#67c23a] ' : ''), children: loadingState === 'success'
                    ? I18n.format('modules.global.ai.crop.complete')
                    : I18n.format('modules.global.ai.croping.photo') })) : (_jsxs("div", { className: " _sz-relative _sz-z-10 _sz-mt-10 _sz-grid _sz-w-full _sz-gap-y-3 _sz-px-8", children: [_jsx("button", { type: "button", onClick: tryAgainWhenError, className: " _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-py-3 _sz-text-base _sz-font-medium _sz-text-white", children: I18n.format('modules.global.try.again') }), _jsx("button", { type: "button", onClick: cropWhenError, className: "_sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border _sz-border-solid _sz-bg-white _sz-py-[11px] _sz-text-base _sz-font-medium  _sz-text-black", children: I18n.format('modules.global.crop.myself') }), _jsx("button", { type: "button", onClick: replaceWhenError, className: "_sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border _sz-border-solid _sz-bg-white _sz-py-[11px] _sz-text-base _sz-font-medium  _sz-text-black", children: I18n.format('modules.global.replace.photo') })] }))] }));
};
export default RecognitionLoading;
